import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { CouponSummary } from '../../interfaces/Coupon/CouponSummary';
import { CouponFilter } from '../../interfaces/Coupon/CouponFilter';
import { getCoupons } from '../../api/Coupon';
import { PaginatedResponse } from '../../interfaces/PaginatedResponse';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { SearchBox } from '../../components/SearchBox/SearchBox';
import { CouponsTable } from './CouponsTable';

export const CouponsPage = () => {
  const navigate = useNavigate();

  const [coupons, setCoupons] = useState<PaginatedResponse<CouponSummary>>({
    data: [],
    totalCount: 0,
  });
  const [filter, setFilter] = useState<CouponFilter>({
    search: '',
    pagination: {
      page: 0,
      pageSize: 10,
    },
  });
  const [loading, setLoading] = useState(false);

  const refreshCoupons = () => {
    setLoading(true);
    getCoupons(filter)
      .then((c) => setCoupons(c))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshCoupons();
  }, [filter]);

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Kuponlar
      </Typography>
      <Waiting open={loading} />

      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Button
          variant='contained'
          startIcon={<AddIcon />}
          onClick={() => navigate('/sales/coupons/new')}
          sx={{ ...sharedStyles.buttonText, mb: 1.5 }}
        >
          Yeni Kupon
        </Button>
        <Box sx={{ flexGrow: 1 }} />
        <SearchBox
          placeholder='Kupon Ara'
          initialValue={filter.search ?? ''}
          onChange={(s) =>
            setFilter({
              ...filter,
              search: s,
              pagination: { ...filter.pagination, page: 0 },
            })
          }
        />
      </Box>

      <CouponsTable
        coupons={coupons.data}
        totalCount={coupons.totalCount}
        pagination={filter.pagination}
        onPagination={(p) => setFilter({ ...filter, pagination: p })}
      />
    </Box>
  );
};
